import { render, staticRenderFns } from "./DealerWaitStatusTag.vue?vue&type=template&id=07445ace"
import script from "./DealerWaitStatusTag.vue?vue&type=script&lang=js"
export * from "./DealerWaitStatusTag.vue?vue&type=script&lang=js"
import style0 from "./DealerWaitStatusTag.vue?vue&type=style&index=0&id=07445ace&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports